import React from 'react'
import { MDBFooter } from 'mdbreact'
const Footer = () => {
    return (
        <div>
              
    <MDBFooter 
    style={{
        position: "relative",
        left: "0",
        bottom: "0",
        width: "100%"
    }}
    className="page-footer font-small elegant-color white-text elegant-color z-depth-1  pt-4"
    >

      <div class="container-fluid text-center text-md-left">
          <div class="row">
              <div class="col-md-6 mt-md-0 mt-3">
                <h5 class="text-uppercase">VISKHA DAIRY</h5>
                <p>Here you can use rows and columns to organize your footer content.</p>
             </div>

                  <hr class="clearfix w-100 d-md-none pb-3" />
                    <div class="col-md-3 mb-md-0 mb-3">
                      <h5 class="text-uppercase">Links</h5>
                      <ul class="list-unstyled">
                        <li>
                          <a href="#!">Board Directors</a>
                        </li>
                        <li>
                          <a href="#!">CEO</a>
                        </li>
                        <li>
                          <a href="#!">About us</a>
                        </li>
                        <li>
                          <a href="#!">Products</a>
                        </li>
                      </ul>
                    </div>
                  

  
                <div class="col-md-3 mb-md-0 mb-3">
                  <h5 class="text-uppercase">Links</h5>
                  <ul class="list-unstyled">
                    <li>
                      <a href="#!">Press Realse</a>
                    </li>
                    <li>
                      <a href="#!">Carrers</a>
                    </li>
                  </ul>
                </div>
           </div>
    </div>

        <div class="footer-copyright text-center py-3">© 2020 Copyright:
          <a href="https://mdbootstrap.com/education/bootstrap/"> dairy.com</a>
        </div>

 </MDBFooter>

        </div>
    )
}

export default Footer
